<div
  *ngIf="screen() as screen"
  #overlay
  class="dsg-screen-popup-backdrop"
  [class.is-dragging]="dragging()"
  (click)="onBackdropClick()"
>
  <div
    class="dsg-screen-popup-dialog"
    role="dialog"
    aria-modal="true"
    [attr.aria-label]="screen.name"
    [ngStyle]="dialogStyles()"
    (click)="$event.stopPropagation()"
  >
    <app-design-screen-preview [screen]="screen" mode="native"></app-design-screen-preview>

    <!-- Builder: drag here to place the popup; it opens at that spot from now on. -->
    <div
      *ngIf="editable()"
      class="dsg-screen-popup-grip"
      matTooltip="Drag to place the popup — it opens here from now on"
      (pointerdown)="startMove($event)"
    >
      <mat-icon>drag_indicator</mat-icon>
      <span>Drag to place</span>
      <button
        *ngIf="placed()"
        type="button"
        class="dsg-screen-popup-centre"
        matTooltip="Open in the middle of the window again"
        (pointerdown)="$event.stopPropagation()"
        (click)="centre()"
      >Centre</button>
    </div>

    <button type="button" class="dsg-screen-popup-close" aria-label="Close popup" title="Close (Esc)" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>

    <!-- Builder: resize the popup (its frame) — the content rescales with it. -->
    <div
      *ngIf="editable()"
      class="dsg-screen-popup-resize"
      matTooltip="Drag to resize"
      (pointerdown)="startResize($event)"
    ></div>
  </div>
</div>
